import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Services = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <Helmet>
        <title>Lead Generation Services - SMS Marketing, Email Campaigns | Cargo Engage</title>
        <meta name="description" content="Comprehensive lead generation solutions for financial services: SMS marketing, email campaigns, lead qualification, and campaign management. 100% TCPA and CTIA compliant." />
        <meta name="keywords" content="lead generation services, SMS marketing, email campaigns, financial leads, mortgage leads, A2P messaging, TCPA compliant marketing" />
      </Helmet>
      {/* Hero Section */}
      <section style={{background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', color: 'white', padding: '80px 20px', textAlign: 'center'}}>
        <div className="container">
          <h1 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem'}}>Our Services</h1>
          <p style={{fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', opacity: '0.95'}}>
            Comprehensive lead generation and marketing solutions for the financial services industry
          </p>
        </div>
      </section>

      {/* Main Services */}
      <section className="section">
        <div className="container">
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '3rem'}}>
            
            {/* Lead Generation */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb', transition: 'all 0.3s'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #1e3c72, #2a5298)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>Lead Generation</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                We generate high-quality, verified leads for financial service providers. Our multi-channel approach ensures you receive qualified prospects actively seeking financial solutions.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>Mortgage & refinance leads</li>
                <li>Personal loan inquiries</li>
                <li>Business financing leads</li>
                <li>Auto loan prospects</li>
                <li>Debt consolidation leads</li>
              </ul>
            </div>

            {/* SMS Marketing */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #2a5298, #1e3c72)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                  <line x1="12" y1="18" x2="12.01" y2="18"></line>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>SMS Marketing</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Compliant text message campaigns that engage leads and drive conversions. All campaigns follow TCPA and CTIA guidelines with proper consent management.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>A2P 10DLC compliant messaging</li>
                <li>Automated drip campaigns</li>
                <li>Real-time lead notifications</li>
                <li>Two-way SMS conversations</li>
                <li>Opt-out management</li>
              </ul>
            </div>

            {/* Email Marketing */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #1e3c72, #2a5298)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>Email Campaigns</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Professional email marketing that nurtures leads through the customer journey. Personalized content that converts prospects into customers.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>Automated email sequences</li>
                <li>Personalized content delivery</li>
                <li>A/B testing & optimization</li>
                <li>CAN-SPAM compliant</li>
                <li>Detailed analytics & reporting</li>
              </ul>
            </div>

            {/* Campaign Management */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #2a5298, #1e3c72)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <line x1="12" y1="1" x2="12" y2="23"></line>
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>Campaign Management</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Full-service campaign management ensuring optimal performance and ROI. We handle everything from strategy to execution and optimization.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>Campaign strategy & planning</li>
                <li>Multi-channel coordination</li>
                <li>Performance tracking</li>
                <li>ROI optimization</li>
                <li>Monthly reporting & insights</li>
              </ul>
            </div>

            {/* Lead Qualification */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #1e3c72, #2a5298)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>Lead Qualification</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Advanced lead scoring and qualification processes ensure you receive only the highest quality prospects ready to convert.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>Real-time lead verification</li>
                <li>Credit profile screening</li>
                <li>Intent validation</li>
                <li>Duplicate detection</li>
                <li>Quality scoring system</li>
              </ul>
            </div>

            {/* Compliance Services */}
            <div style={{background: '#fff', padding: '2.5rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '2px solid #e5e7eb'}}>
              <div style={{width: '80px', height: '80px', background: 'linear-gradient(135deg, #2a5298, #1e3c72)', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.5rem'}}>
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                </svg>
              </div>
              <h3 style={{color: '#1e3c72', fontSize: '1.5rem', fontWeight: '700', marginBottom: '1rem'}}>Compliance & Privacy</h3>
              <p style={{color: '#4b5563', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                Complete compliance management ensuring all lead generation activities meet regulatory requirements and industry standards.
              </p>
              <ul style={{color: '#6b7280', lineHeight: '2', paddingLeft: '1.5rem'}}>
                <li>TCPA compliance management</li>
                <li>CTIA guidelines adherence</li>
                <li>Consent documentation</li>
                <li>Privacy policy enforcement</li>
                <li>Regular compliance audits</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section" style={{background: '#f8fafc'}}>
        <div className="container">
          <h2 className="section-title">Why Choose Cargo Engage?</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', marginTop: '3rem'}}>
            <div style={{textAlign: 'center', padding: '2rem'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🎯</div>
              <h3 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>Quality Leads</h3>
              <p style={{color: '#6b7280'}}>Verified, high-intent prospects ready to engage with financial services</p>
            </div>
            <div style={{textAlign: 'center', padding: '2rem'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>✅</div>
              <h3 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>Full Compliance</h3>
              <p style={{color: '#6b7280'}}>100% TCPA and CTIA compliant lead generation and marketing</p>
            </div>
            <div style={{textAlign: 'center', padding: '2rem'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📊</div>
              <h3 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>Real-Time Reporting</h3>
              <p style={{color: '#6b7280'}}>Comprehensive analytics and performance tracking dashboards</p>
            </div>
            <div style={{textAlign: 'center', padding: '2rem'}}>
              <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🤝</div>
              <h3 style={{color: '#1e3c72', marginBottom: '0.5rem'}}>Dedicated Support</h3>
              <p style={{color: '#6b7280'}}>Expert account management and responsive customer service</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section" style={{background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', color: 'white'}}>
        <div className="container" style={{textAlign: 'center'}}>
          <h2 style={{fontSize: '2.5rem', marginBottom: '1rem'}}>Ready to Get Started?</h2>
          <p style={{fontSize: '1.25rem', marginBottom: '2rem', opacity: '0.95'}}>
            Contact us today to discuss your lead generation needs
          </p>
          <Link to="/contact" className="cta-button">Request Information</Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
